// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KfMu","label":"styles_label__3Jn-D"};